import { FamilyMember } from '../types'
import familyTreeData from '../data/family_tree_data.json'

interface UseFamilyTreeDataReturn {
    data: FamilyMember | null
    loading: boolean
    error: string | null
}

// 将数字转换为中文数字
const toChineseNum = (num: number): string => {
    const chineseNums = [
        '零',
        '一',
        '二',
        '三',
        '四',
        '五',
        '六',
        '七',
        '八',
        '九',
    ]
    const units = ['', '十', '百', '千']

    if (num < 10) {
        return chineseNums[num]
    } else if (num === 10) {
        return '十'
    } else if (num < 20) {
        return `十${chineseNums[num % 10]}`
    }
    // 可以根据需要扩展更复杂的转换逻辑
    return num
        .toString()
        .split('')
        .reverse()
        .map((digit, index) => {
            const numDigit = parseInt(digit, 10)
            if (numDigit === 0) {
                return ''
            }
            return `${chineseNums[numDigit]}${units[index]}`
        })
        .reverse()
        .join('')
}

// 递归函数，为每个节点添加代数信息
const addGenerationNotes = (
    node: FamilyMember,
    depth: number = 0,
): FamilyMember => {
    // 确保 notes 数组存在
    if (!node.notes) {
        node.notes = []
    }

    let generationText: string
    if (depth === 0) {
        generationText = '迁祖'
    } else {
        generationText = `${toChineseNum(depth)}世祖`
    }

    // 将代数信息添加到 notes 数组的开头
    node.notes.unshift(generationText)

    // 递归处理子节点
    if (node.children && node.children.length > 0) {
        node.children = node.children.map((child) =>
            addGenerationNotes(child, depth + 1),
        )
    }

    return node
}

export const useFamilyTreeData = (): UseFamilyTreeDataReturn => {
    // 创建一个深拷贝来避免在热重载或多次渲染时重复添加
    const rawData = JSON.parse(JSON.stringify(familyTreeData)) as FamilyMember

    // 处理数据，添加代数信息
    const dataWithGenerations = addGenerationNotes(rawData)

    return {
        data: dataWithGenerations,
        loading: false, // 数据已同步可用，不再需要loading状态
        error: null, // 直接import不会有网络错误
    }
}
